import { ServiceFetch } from '../service-fetch'

export default class SaleChangeInListModel extends ServiceFetch {
    getSaleChangeInListBy = (data) => this.authFetch({
        url: 'sale-change-in-list/getSaleChangeInListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}